import { DirectiveFunction } from 'vue'
import { router } from '@/router'
import { hasRight } from '@/service/session/permission'

export const permission: DirectiveFunction = async (el, { value }) => {
  const key = router.currentRoute.meta!.key
  const access = await hasRight(key, value)
  if (!access && el.parentNode) {
    el.parentNode.removeChild(el)
  }
}
